import React , { useState } from "react";
import styled from "@emotion/styled";
import colors from '../../../sass/brand_palette.scss';
import { Modal } from "./Modal";
import withTranslator from "../Translator/withTranslation";

const BadgesContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-self: stretch;
    position: relative;
    width: ${(100 * 10) / 12}%;
    margin-left:auto;
    margin-right:auto;
    @media (max-width: 600px) {
      height:auto;
      display: block;
      text-align:center;
    }
    @media (max-width: 1024px) {
        width:100%;
        margin:0px;
        align-items:flex-start;
    }
`;
const Badge = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    flex:1;
    @media (max-width: 1024px) {
        flex-direction:column;
        text-align:center;
    }
`;

const BadgeWidget = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    @media (max-width: 1024px) {
        padding-bottom:15px;      
        width:100%;
        text-align:center;
          margin:0 auto;
    }
`;

const BadgeWidgetImg = styled.img`
    width: auto;
    height: 30px;
    @media (max-width: 767px) {
        max-width:30px;
    }
    @media (max-width: 600px) {
        height: 80px;
        margin: 60px 0 15px;
    }
`;

const BadgeTextContainer = styled.div`
    color: ${colors.grey1};
    line-height: 1.3em;
    
    @media (max-width: 600px) {
        font-size: 1em;
        font-weight: bold;
        text-shadow: 1px 1px 1px ${colors.blue1}
    }
`;

const BadgeTextInner = styled.div`
    display:inline-block;
`;

const BadgeText = ({ children }) => (
  <BadgeTextContainer className="pl-2 font-w600 inline-block">
    <BadgeTextInner>{children}</BadgeTextInner>
  </BadgeTextContainer>
);

const BadgesComponent = (props) => {
    const [modalContent, setModal] = useState(false);
    const onClose = () => {
        setModal(null);
    }
    const modal = (route) => {
        setModal(<Modal key="modalLoading" loading={true} onClose={onClose} />);

        fetch(route)
            .then(response => response.text())
            .then(data => setModal(
               <Modal 
                key="modalLoaded"
                content={data}
                setHTML={true}
                onClose={onClose}
                />
            ))
    }
    const { t } = props;

    return (
        <div>
            {modalContent ? modalContent : ''}
            <BadgesContainer className="font-80 py-3">
                <Badge onClick={() => modal('/satisfaction')} className="pointer">
                    <BadgeWidget>
                        <BadgeWidgetImg alt={t('satisfactionguarantee_100')} src="/assets/img/front/icons/satisfactionv3-blue3.svg" />
                    </BadgeWidget>
                    <BadgeText>{t('satisfactionguarantee_100')}</BadgeText>
                </Badge>
                <Badge onClick={() => modal('/lowestprice')} className="pointer">
                    <BadgeWidget>
                        <BadgeWidgetImg alt={t('lowerGuaranteed')} src="/assets/img/front/icons/lowestpricev2-blue3.svg" />
                    </BadgeWidget>
                    <BadgeText>{t('lowerGuaranteed')}.</BadgeText>
                </Badge>
                <Badge>
                    <BadgeWidget>
                        <BadgeWidgetImg alt={t('great_rating')} src="/assets/img/front/icons/trustpilot-blue3.svg" />
                    </BadgeWidget>
                    <BadgeText>
                        <div className="lowercase">4.5 / 5 {t('based')} {t('on')} 280 {t('reviews')}</div>
                        {(!props.mobile && !props.tablet) && <div>{t('great_rating')} Trustpilot</div> }
                    </BadgeText>
                </Badge>
                <Badge>
                    <BadgeWidget>
                        <BadgeWidgetImg alt={t('usp_professionalcleaning')} src="/assets/img/front/icons/professional-cleaning-blue3.svg" />
                    </BadgeWidget>
                    <BadgeText><div dangerouslySetInnerHTML={ { __html: t('usp_professionalcleaning')} } ></div></BadgeText>
                </Badge>
                <Badge>
                    <BadgeWidget>
                        <BadgeWidgetImg alt={t('safe_payment')} src="/assets/img/front/icons/mastercard-visa-blue3.svg" className="pt-1" />
                    </BadgeWidget>
                    <BadgeText><div dangerouslySetInnerHTML={ { __html: t('safe_payment')} } ></div></BadgeText>
                </Badge>
            </BadgesContainer>
        </div>
    );
}

export const Badges = withTranslator(BadgesComponent);